module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.0b2861bb.svg";